const productGroupEndpoints = {
  accounting: () => '/reporting/products/groups/accounting'
}

export default productGroupEndpoints
